import clsx from 'clsx';
import React from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {UNIT} from '@di-shared/const';

function SafeDrivingSectionLoadingKr() {
  const {t} = useInferableTranslation();

  return (
    <section className={clsx('section section_safe_score skeleton')}>
      <div className="section_container">
        <div className="section_container_header skeleton">
          <h3 className="body_medium_b skeleton">{t('T20045')}</h3>
          <span
            className="ic ic_arrow_forward_16px skeleton"
            aria-hidden="true"
          ></span>
        </div>
        <div className="safe_score_info skeleton">
          <strong className="safe_score_title">
            <span className="safe_score_value">80</span>
            <span className="safe_score_unit">{t('T10056')}</span>
          </strong>
          <span className="safe_score_compare">
            <span className="score_compare_text">{t('T20052')}</span>
            <span className={clsx('score_compare_value')}>{t('T20006_$score', {score: 30})}</span>
          </span>
          <div className="safe_score_percent">
            <span className="score_percent_item">
              <span className="score_percent_text">{t('T20053')}</span>
              <span className="score_percent_value">{`${Math.max(1, 20)}${UNIT.PERCENT}`}</span>
            </span>
            <span className="divider divider_vertical"></span>
            <span className="score_percent_item">
              <span className="score_percent_text">GV70 {t('T20053')}</span>
              <span className="score_percent_value">{`${Math.max(1, 20)}${UNIT.PERCENT}`}</span>
            </span>
          </div>
        </div>
        <div className="safe_score_summary">
          <ul className="score_summary_list">
            <li className="score_summary_item skeleton">
              <span className="ic ic_map_point_up_16"></span>
              <span className="score_summary_title">{t('T10011')}</span>
              <span className="score_summary_value">{t('T30145_$count', {count: 5})}</span>
            </li>
            <li className="score_summary_item skeleton">
              <span className="ic ic_map_point_down_16"></span>
              <span className="score_summary_title">{t('T10012')}</span>
              <span className="score_summary_value">{t('T30145_$count', {count: 4})}</span>
            </li>
            <li className="score_summary_item skeleton">
              <span className="ic ic_map_point_sudden_16"></span>
              <span className="score_summary_title">{t('T10013')}</span>
              <span className="score_summary_value">{t('T30145_$count', {count: 3})}</span>
            </li>
            <li className="score_summary_item skeleton">
              <span className="ic ic_map_point_night_16"></span>
              <span className="score_summary_title">{t('T20000')}</span>
              <span className="score_summary_value">{t('T30145_$count', {count: 2})}</span>
            </li>
          </ul>
        </div>
        <a
          role="button"
          className="section_container_full_btn"
        >
          <span className="blind">{t('T20087')}</span>
        </a>
      </div>
    </section>
  );
}

export default SafeDrivingSectionLoadingKr;
